// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PortalClose = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m9.718 8 5.926-5.926A1.215 1.215 0 1 0 13.925.356L8 6.28 2.074.356A1.216 1.216 0 0 0 .356 2.074L6.282 8 .356 13.925a1.215 1.215 0 1 0 1.718 1.719L8 9.718l5.925 5.926a1.21 1.21 0 0 0 1.719 0 1.215 1.215 0 0 0 0-1.719L9.718 8Z"
			fill="#555"
		/>
	</svg>
);
export default PortalClose;
